/* eslint-disable react/jsx-props-no-spreading */
import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { ScrollToTopButton as ScrollToTopButtonIO } from '@doda/io-react/pc';
import {
  JobDetailResponse,
  ScoutJobDetailResponse,
} from '@doda/api-client/aspida/@types';
import { Footer } from 'components/Footer';
import { loginStatusSelector } from '@doda/common/src/redux/features/memberInfo';
import { JOB_SEARCH_DETAILS_EXTERNAL_SITE_LINK_LIST } from '../../constants';
import type { Tab } from '../../types/tab';
import {
  FollowHeader,
  FollowHeaderProvider,
  getFollowHeaderProps,
  useDisplayState,
} from '../FollowHeader';
import {
  getPromoteApplicationModalProps,
  PromoteApplicationModal,
  PromoteApplicationModalProvider,
  showPromoteApplicationModal,
} from '../PromoteApplicationModal';
import styles from './index.module.scss';
import { useAppSelector } from '../../../../../../redux/hooks';
import { JobSearchDetailHeader } from '../JobSearchDetailHeader';

/**
 * Props
 */
interface Props {
  children: ReactNode;
  job: JobDetailResponse | ScoutJobDetailResponse;
  isScout: boolean;
  initialTab: Tab;
  applyButtonChangeAbTestGroupNo?: string;
  isCasualInterview?: boolean;
  worschrsvid?: string | null;
}

export const PageLayout: FC<Props> = ({
  children,
  job,
  isScout,
  initialTab,
  applyButtonChangeAbTestGroupNo,
  isCasualInterview,
  worschrsvid,
}) => {
  const isLoggedIn = useAppSelector(loginStatusSelector);

  return (
    <FollowHeaderProvider>
      <PromoteApplicationModalProvider>
        <JobSearchDetailHeader isLoggedIn={isLoggedIn} />
        <main>{children}</main>
        <div className={styles['jobSearchDetail-pageLayout__footer']}>
          <Footer
            externalSiteLinkList={JOB_SEARCH_DETAILS_EXTERNAL_SITE_LINK_LIST}
          />
        </div>
        <FollowHeader
          {...getFollowHeaderProps(
            job,
            isScout,
            initialTab,
            applyButtonChangeAbTestGroupNo,
            isCasualInterview,
            worschrsvid
          )}
        />
        <ScrollToTopButton />
        {showPromoteApplicationModal(job) && (
          <PromoteApplicationModal
            {...getPromoteApplicationModalProps(
              job,
              isScout,
              initialTab,
              applyButtonChangeAbTestGroupNo,
              isCasualInterview,
              worschrsvid
            )}
          />
        )}
      </PromoteApplicationModalProvider>
    </FollowHeaderProvider>
  );
};

const ScrollToTopButton = () => {
  // 追従ヘッダーが表示されている間は上部へ戻るボタンの位置を上げる
  const showHeader = useDisplayState();
  return (
    <ScrollToTopButtonIO
      className={classNames(
        styles['jobSearchDetail-pageLayout__scrollButton'],
        {
          [styles['jobSearchDetail-pageLayout__scrollButton--up']]: showHeader,
        }
      )}
    />
  );
};
